import React from 'react'

export default function HeadLine(props) {
    return (
        <div className={`headline ${props.className}`  } >
            <h4> {props.title } </h4>
        </div>
    )
}
